App.IncidentReportsTable = class extends App.DataTable {
  constructor(table, dataSourceUrl, noDataText, inProgress = false) {
    let columns = [
      {
        sortable: false,
        render: function ( data, type, full, meta ) {
          let link = full.can_edit ?
            `/organizations/${full.organization_id}/incident_reports/${full.id}/edit`
          :
            `/organizations/${full.organization_id}/incident_reports/${full.id}`

          return `<a href="${link}" class="btn btn-xs btn-muted-blue" >View</a>`;
        },
        width: '48px'
      },
      {
        data: "id",
        className: 'all',
        width: '60px'
      },
      {
        data: "claim_contact_name",
        className: 'all',
        width: '120px'
      },
      {
        data: "status",
        width: '75px'
      },
      {
        data: "incident_happened_at",
        type: "date",
        width: '130px',
        render: function( data, type, full, meta ) {
          var date = Date.parse(full.incident_happened_at);
          return isNaN(date) ? '' : new Date(full.incident_happened_at).toLocaleDateString("en-US");
        }
      },
      {
        data: "updated_at",
        type: "date",
        width: '80px',
        render: function( data, type, full, meta ) {
          var date = Date.parse(full.updated_at);
          return isNaN(date) ? '' : new Date(full.updated_at).toLocaleDateString("en-US");
        }
      }
    ];

    // Claimant columns
    if (!inProgress) {
      columns.push({
        sortable: false,
        render: function ( data, type, full, meta ) {
          return `<ul class='small list-unstyled truncate'>${
                    full.claimants.map((claimant) =>
                      `<li title='${claimant.claimant_name}'>${claimant.claimant_name}</li>`
                    ).join('') }
                  </ul>`;
        },
        width: '110px'
      });

      columns.push({
        sortable: false,
        render: function ( data, type, full, meta ) {
          return `<ul class='small list-unstyled'>${
                    full.claimants.map((claimant) =>
                      `<li>${claimant.claim_number}</li>`
                    ).join('') }
                  </ul>`;
        },
        width: '115px'
      });
    }

    if (inProgress) {
      columns.push({
        sortable: false,
        render: function ( data, type, full, meta ) {

          if (!full.can_edit) {
            return null;
          }

          return [
            `<a href="/organizations/${full.organization_id}/incident_reports/${full.id}/"`,
               'data-method="delete"',
               'data-title="Confirm Report Deletion"',
               'data-confirm="Are you sure you want to delete this report?"',
               'data-remote="true"',
               'data-behavior="propagate-click-event incident_report_delete_link"',
               'rel="nofollow"',
               'class="btn btn-xs btn-danger">',

              'Delete',
            '</a>'
          ].join('');
        },
        width: '48px'
      });
    }

    const noData = '<span class="fa fa-info-sign"></span><p>' + noDataText + '</p>';

    const searchFilterHtml = {
      'filter-incident-happened-at': "<input type='text' class='form-control input-sm filter-text' placeholder='mm/dd/yyyy' name='filter-date-input' />"
    };

    super({ table: table, dataSourceUrl: dataSourceUrl, columns: columns, noData: noData, initialOrder: !inProgress && [[4, 'desc']], searchFilterHtml: searchFilterHtml });
  }
}

$(document).on('turbo:load', function() {
  if($(".incident_reports.index").length == 0) return;

  var submittedReportsTable = new App.IncidentReportsTable($("#submitted-reports"), '/incident_reports/data_table/submitted', "No reports have been submitted.", false);
  submittedReportsTable.render();

  var reportsInProgressTable = new App.IncidentReportsTable($("#reports-in-progress"), '/incident_reports/data_table/in_progress', "There are currently no reports in progress.", true);
  reportsInProgressTable.render();
});

$(document).on("ajax:success", "[data-behavior~=incident_report_delete_link]", function(data, status, xhr) {
  let link_row = $(this).parents("tr");
  let data_table = $(this).parents("table").DataTable();

  data_table.row(link_row).remove();
  data_table.draw();
});
